module.exports = "<div class=sb-empty-box> <i class=\"fa fa-3x {{ $ctrl.iconCss }}\" aria-hidden=true></i> <h1 translate>{{ $ctrl.title }}</h1> <p class=text-muted translate>{{ $ctrl.message }}</p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/empty-box/empty-box.html
// module id = 240
// module chunks = 0